import { render, staticRenderFns } from "./NotificationCard.vue?vue&type=template&id=24b6678a&"
import script from "./NotificationCard.vue?vue&type=script&lang=ts&"
export * from "./NotificationCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports